/** @jsx h */
import { Component, h, JSX } from 'preact';
import { hexToRGBA } from '../../../../../../common/js/colors';
import {
  sendAnalyticsTrack,
  sendCreativeExpand
} from '../../../../../../common/js/TrackAnalyticsHelper';
import { RootStore } from '../../../../../../common/js/stores/root.store';
import ExpandControl from '../../../../../../common/components/expand-control';
import CustomizedControl from '../../../../../../common/components/customized-control';
import InformationLabel from '../../../../../../common/components/information-label';

interface ControlStyle {
  backgroundColor: string;
  backgroundOpacity: number;
  labelColor: string;
  labelOpacity: number;
}

interface CtaExpandItemProps {
  onToggleExpand: (isExpanded: boolean) => void;
  controlStyle: ControlStyle;
  remainingTime: number;
  showRecommendation: boolean;
  canInstallIcon: boolean;
  isReversed: boolean;
}

export class CtaExpandItem extends Component<CtaExpandItemProps> {
  constructor(props: CtaExpandItemProps) {
    super(props);
  }

  render(): JSX.Element {
    const {
      onToggleExpand,
      controlStyle,
      remainingTime,
      showRecommendation,
      canInstallIcon,
      isReversed
    } = this.props;
    const isExpanded = RootStore.getInstance().videoStore.isVideoExpanded.value;
    const containerStyle = {
      display: 'inline-flex',
      flexDirection: isReversed ? 'row-reverse' : 'row',
      background: hexToRGBA(
        controlStyle.backgroundColor,
        controlStyle.backgroundOpacity
      ),
      color: hexToRGBA(controlStyle.labelColor, controlStyle.labelOpacity),
      fill: hexToRGBA(controlStyle.labelColor, controlStyle.labelOpacity),
      fontSize: 13,
      borderRadius: 6,
      alignItems: 'center',
      minHeight: 36
    };

    const configStore = RootStore.getInstance().configStore;

    const showCloseDelay =
      configStore.config.closeBtn && configStore.config.closeBtn.showCloseDelay;

    const canShowInformationLabel = Boolean(
      showRecommendation || canInstallIcon || showCloseDelay
    );

    const informationLabelItem = canShowInformationLabel && (
      <InformationLabel
        remainingTime={remainingTime}
        showRecommendation={showRecommendation}
        canInstallIcon={canInstallIcon}
        styles={{
          paddingLeft: isReversed ? 8 : 12,
          paddingRight: !isReversed ? 8 : 12
        }}
      />
    );

    const expandItem = (
      <div data-zone="expand">
        <CustomizedControl
          id="expand"
          onTouchStart={(e: TouchEvent) => e.stopPropagation()}
          onClick={(e: MouseEvent) => {
            e.stopPropagation();
            sendAnalyticsTrack(e, isExpanded ? 'collapse' : 'expand');
            sendCreativeExpand(isExpanded);
            onToggleExpand(isExpanded);
          }}
          controlStyle={controlStyle}
          style={{ padding: 9 }}
        >
          <ExpandControl iconSize={18} />
        </CustomizedControl>
      </div>
    );

    return (
      <div style={containerStyle as any}>
        {informationLabelItem}
        {expandItem}
      </div>
    );
  }
}
